import xxhash, { XXHashAPI } from 'xxhash-wasm';

let hasher: XXHashAPI | null = null;

xxhash().then((_) => {
  hasher = _;
});

export class Hasher {
  hash(inputBuffer: Uint8Array, seed?: number) {
    if (!hasher) {
      throw new Error('Hasher not initialized');
    }
    return hasher.h32Raw(inputBuffer, seed).toString(16).padStart(8, '0');
  }
}

export default Hasher;
